import { Plugin } from 'ckeditor5/src/core';

import { Widget } from 'ckeditor5/src/widget';

import CheckBoxCreateCommand from './commands/CheckBoxCreateCommand';
import CheckBoxChangeCommand from './commands/CheckBoxChangeCommand';
import CheckBoxGetCheckedCommand from './commands/CheckBoxGetCheckedCommand';

import {
	CHECKBOX_ATTR_CHECKED,
	CHECKBOX_ATTR_ID,
	CHECKBOX_COMMANDS,
	COMPONENT_NAME,
	CHECKBOX_OUT_COMMANDS,
	COMPONENT_ATTR_NEW_VALUE, COMPONENT_ATTR_CAN_REVIEW, CHECKBOX_ATTR_ENABLED
} from './constants';

import { enableCheckBoxCommandsOnRestrictedMode } from './utils';
import { upcastCheckBox } from './conversion/upcast';
import { downcastCheckBox } from './conversion/downcast';
import CheckBoxDiffCommand from './commands/CheckBoxDiffCommand';
import CheckBoxDiffBulkCommand from './commands/CheckBoxDiffBulkCommand';
import CheckBoxEnabledCommand from './commands/CheckBoxEnabledCommand';

export default class CheckBoxEditing extends Plugin {
	static get requires() {
		return [ Widget ];
	}

	init() {
		this._defineSchema();
		this._defineConverters();

		this.editor.commands.add( CHECKBOX_COMMANDS.CREATE, new CheckBoxCreateCommand( this.editor ) );
		this.editor.commands.add( CHECKBOX_COMMANDS.CHANGE, new CheckBoxChangeCommand( this.editor ) );
		this.editor.commands.add( CHECKBOX_COMMANDS.ENABLED, new CheckBoxEnabledCommand( this.editor ) );
		this.editor.commands.add(
			CHECKBOX_COMMANDS.GET_CONTENT,
			new CheckBoxGetCheckedCommand( this.editor )
		);
		this.editor.commands.add( CHECKBOX_COMMANDS.DIFF, new CheckBoxDiffCommand( this.editor ) );
		this.editor.commands.add( CHECKBOX_COMMANDS.DIFF_BULK, new CheckBoxDiffBulkCommand( this.editor ) );
		enableCheckBoxCommandsOnRestrictedMode( this.editor.plugins );

		const checkBoxCreateCommand = this.editor.commands.get( CHECKBOX_COMMANDS.CREATE );
		checkBoxCreateCommand.delegate( CHECKBOX_OUT_COMMANDS.CREATE ).to( this.editor );

		const checkBoxEnabledCommand = this.editor.commands.get( CHECKBOX_COMMANDS.ENABLED );
		checkBoxEnabledCommand.delegate( CHECKBOX_OUT_COMMANDS.ENABLED ).to( this.editor );

		const checkBoxChangeCommand = this.editor.commands.get( CHECKBOX_COMMANDS.CHANGE );
		checkBoxChangeCommand.delegate( CHECKBOX_OUT_COMMANDS.CHANGE ).to( this.editor );

		const checkBoxGetCheckedCommand = this.editor.commands.get( CHECKBOX_COMMANDS.GET_CONTENT );
		checkBoxGetCheckedCommand.delegate( CHECKBOX_OUT_COMMANDS.GET_CHECKED ).to( this.editor );

		const checkBoxDiffCommand = this.editor.commands.get( CHECKBOX_COMMANDS.DIFF );
		checkBoxDiffCommand.delegate( CHECKBOX_OUT_COMMANDS.DIFF ).to( this.editor );

		const checkBoxDiffBulkCommand = this.editor.commands.get( CHECKBOX_COMMANDS.DIFF_BULK );
		checkBoxDiffBulkCommand.delegate( CHECKBOX_OUT_COMMANDS.DIFF_BULK ).to( this.editor );
	}

	destroy() {
		this.stopListening();
	}

	_defineSchema() {
		const schema = this.editor.model.schema;

		schema.register( COMPONENT_NAME, {
			allowWhere: '$text',
			allowIn: COMPONENT_NAME,
			isInline: true,
			isObject: true,
			allowAttributesOf: '$text',
			allowAttributes: [
				CHECKBOX_ATTR_ENABLED,
				CHECKBOX_ATTR_CHECKED,
				CHECKBOX_ATTR_ID,
				COMPONENT_ATTR_NEW_VALUE,
				COMPONENT_ATTR_CAN_REVIEW
			]
		} );
	}

	/**
   * https://ckeditor.com/docs/ckeditor5/latest/assets/img/upcast-pipeline.svg
   * -------------------------- MODEL ------------------------------
   * _______________________________________________________________
   *---------- In -------------- Out ------|---------- In ----------
   *---------- | ---------------- | -------|---------- | -----------
   *---------- | ---------------- | -------|---------- | -----------
   *--- data downcast ---- data upcast ----|-- editing downcast ----
   * ---------- | ---------------- | ------|---------- | -----------
   * ---------- | ---------------- | ------|---------- | -----------
   * --------- Out ------------- In -------|--------- Out ----------
   * ------ data view  --------------------|----- editing view -----
   */
	_defineConverters() {
		const editor = this.editor;
		const conversion = this.editor.conversion;

		conversion.for( 'upcast' ).elementToElement( {
			view: { name: 'span', classes: [ 'dw-checkbox' ] },
			model: upcastCheckBox
		} );

		conversion.for( 'editingDowncast' ).elementToElement( {
			model: {
				name: COMPONENT_NAME,
				attributes: [ CHECKBOX_ATTR_ENABLED, CHECKBOX_ATTR_CHECKED, COMPONENT_ATTR_NEW_VALUE, COMPONENT_ATTR_CAN_REVIEW ]
			},
			view: downcastCheckBox( editor, { asWidget: true } )
		} );

		conversion.for( 'dataDowncast' ).elementToElement( {
			model: COMPONENT_NAME,
			view: downcastCheckBox( editor, { asWidget: false } )
		} );
	}
}
